// ErrorBoundary.jsx
import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props){ super(props); this.state = { hasError: false }; }
  static getDerivedStateFromError(){ return { hasError: true }; }
  componentDidCatch(err, info){ /* optionally log */ }
  render(){
    if (this.state.hasError) return <div style={{padding:16}}>Header failed to load.</div>;
    return this.props.children;
  }
}
